import { Navigate } from "react-router-dom";
import { useUserStore } from "@/stores/use-user-store";
import { getUserInitialDepartmentRoute } from "@/utils/department-routes";

interface PublicRouteProps {
  children: React.ReactNode;
}

export function PublicRoute({ children }: PublicRouteProps) {
  const { activeUser } = useUserStore();

  if (activeUser) {
    // Redirecionar para a rota correta baseada no primeiro department autorizado do usuário
    const redirectPath = getUserInitialDepartmentRoute(activeUser);

    if (redirectPath) {
      return <Navigate to={redirectPath} replace />;
    }
  }

  return <>{children}</>;
}
